// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Offline_pageWrapper__xnXbP","imgWrapper":"Offline_imgWrapper__pVp-C","title":"Offline_title__2N8-c","subtitle":"Offline_subtitle__Rn4zR"};